import { ShiftPublishState } from '@frontend/graphql/types.generated'

import type { ShiftWithSlots } from './types'

const PUBLISHABLE_STATES = [
  ShiftPublishState.Draft,
  ShiftPublishState.UnpublishedChanges,
  ShiftPublishState.PendingRemoval,
]

const LIVE_TO_VOLUNTEERS = [
  ShiftPublishState.Published,
  ShiftPublishState.UnpublishedChanges,
  ShiftPublishState.PendingRemoval,
]

export const isPublishable = (shift: ShiftWithSlots): boolean => PUBLISHABLE_STATES.includes(shift.publishState)

export const isLiveToVolunteers = (shift: ShiftWithSlots): boolean => LIVE_TO_VOLUNTEERS.includes(shift.publishState)

export const isPendingRemoval = (shift: ShiftWithSlots): boolean =>
  shift.publishState === ShiftPublishState.PendingRemoval

export const hasPerShiftPublish = (shift: ShiftWithSlots): boolean =>
  shift.publishState === ShiftPublishState.Draft || shift.publishState === ShiftPublishState.UnpublishedChanges
